'use client';

import type { ReactNode } from 'react';
import type { ConclusionType } from '~/model/ConclusionType';
import type { SectionType } from '~/model/SectionType';
import HTMLReactParser from 'html-react-parser';
import { getResizedPictureUrl } from '@/app/utils/entities/media';
import { ResizedImg } from '~/components/commons/ResizedImg/ResizedImg';
import { Zoom } from '~/components/commons/Zoom/Zoom';
import { isSectionEmpty } from './utils';

export const EntityPanel = ({
  entityPanel,
  langValue,
  translateButtonComponent,
}: {
  entityPanel: ConclusionType | SectionType;
  langValue: string;
  translateButtonComponent?: ReactNode;
}) => {
  const noData = isSectionEmpty(entityPanel);

  return (
    !noData && (
      <div className="panel entity">
        <header className="panel__header" />
        <footer className="panel__body">
          <div>
            {entityPanel?.title && (
              <div
                lang={langValue}
                className="vp-title-s"
                data-testid="conclusionTitle"
              >
                {entityPanel.title}
              </div>
            )}
            {entityPanel?.media?.content_url && (
              <div className="entity__media">
                <div className="entity__picture">
                  <ResizedImg
                    src={entityPanel.media.content_url}
                    format="1042x0"
                    width={1042}
                    height={200}
                    alt=""
                    loading="eager"
                  />
                  <Zoom
                    mainSrc={getResizedPictureUrl(
                      entityPanel.media.content_url,
                      '1600x0',
                    )}
                  />
                </div>
              </div>
            )}
            {entityPanel?.body && (
              <div lang={langValue} data-cy="entityPanelBody">
                {HTMLReactParser(entityPanel?.body)}
              </div>
            )}
            {translateButtonComponent}
          </div>
        </footer>
      </div>
    )
  );
};
